export default __webpack_public_path__ + "static/partner-exchange-9ff669b135c992927126c4df78448713.png";